<template>
  <v-container class="restaurant-container ">
    <v-card>
      <v-carousel hide-delimiters :cycle="true">
        <v-carousel-item
          v-for="(item,i) in restaurant.pictures"
          :key="i"
          :src="item"
        >
        </v-carousel-item>
      </v-carousel>
    </v-card>

    <v-container class="grid">
      <v-card class="infos">
        <v-card-title>
          {{ restaurant.name }}
        </v-card-title>
        <v-card-text>
          <v-row
            align="center"
            class="mx-0 mt-1 mb-1"
          >
            <v-icon
              v-for="item in restaurant.price_range"
              :key="item"
            >
              mdi-currency-usd
            </v-icon>
            <v-icon> mdi-circle-small</v-icon>
            <v-rating
              dense
              readonly
              half-increments
              background-color="orange lighten-3"
              color="orange"
              medium
              :value="restaurant.rating"
            ></v-rating>
            <ModalFavoris
              v-bind:user-token="userToken"
              v-bind:restaurant="restaurant"
              v-bind:modal-visible="modalVisible"
              v-bind:logged="logged"
            ></ModalFavoris>
            <ModalVisit
              v-bind:user-token="userToken"
              v-bind:modal-visible="modalVisible"
              v-bind:restaurant-name="restaurant.name"
              v-bind:restaurant-id="restaurant.id"
              v-bind:logged="logged"
            ></ModalVisit>

          </v-row>
          <v-row
            align="center"
            class="mx-0 mt-3 mb-3"
          >
            <v-chip
              v-for="item in restaurant.genres"
              :key="item"
              color="primary"
              class="ml-1"
            >
              {{ item }}
            </v-chip>
          </v-row>
        </v-card-text>
        <v-divider class="mx-4"></v-divider>
        <v-card-title>Contact And Location</v-card-title>
        <v-card-text>
          <v-row
            align="center"
            class="mx-0 mt-3 mb-3"
          >
            <v-icon>mdi-map-marker</v-icon>
            :
            {{ restaurant.address }}
          </v-row>
          <v-row
            align="center"
            class="mx-0 mt-3 mb-3"
          >
            <v-icon>mdi-cellphone</v-icon>
            :
            {{ restaurant.tel }}
          </v-row>
        </v-card-text>
      </v-card>

      <v-card class="hours">
        <v-card-title> Opening Hours</v-card-title>
        <div class="ml-5 ">
          <div
            v-for="(key,item) in restaurant.opening_hours"
            :key="item"
          >
            <div class="mb-7">
              {{ item.charAt(0).toUpperCase() + item.slice(1) }} - {{ key }}
            </div>
          </div>
        </div>
      </v-card>
    </v-container>
    <v-container>
      <v-card >
        <v-card-title> Similar Restaurants </v-card-title>
      </v-card>
      <v-slide-group
        v-model="model"
        class="pa-4"
        active-class="success"
        show-arrows
      >
        <restaurant-card
          v-for="restaurant in similarRestaurants"
          v-bind:key="restaurant.id"
          v-bind:restaurant="restaurant"
          v-bind:restaurants="similarRestaurants"
        ></restaurant-card>
      </v-slide-group>
    </v-container>
    <v-card >
      <v-card-title> Localisation </v-card-title>
    </v-card>
    <v-container>
      <v-card>
        <GoogleMap
          v-bind:restaurant="restaurant"
          v-bind:restaurants="restaurants"
          v-bind:restaurantName="restaurant.name"
        />
      </v-card>
    </v-container>

  </v-container>

</template>

<script>
import GoogleMap from "../components/Map";
import ModalVisit from "../components/Visits/ModalVisit";
import ModalFavoris from "../components/Favorites/ModalFavoris";
import RestaurantServices from "../services/restaurant";
import RestaurantCard from "../components/Restaurants/RestaurantCardSuggestion";
import Api from "../services/api";


export default {
  name: "Restaurant",
  components: {
    GoogleMap,
    ModalFavoris,
    ModalVisit,
    RestaurantCard
  },

  props: ["userToken", "restaurant", 'restaurants'],

  data() {
    return {
      similarRestaurants : [],
      modalVisible : false,
      logged : false,
      filter: {limit : 20, qword : '', genres : '', priceRangeValue : 0},
      pagination: { page: 1, total: 0 },
    }
  },

  async created () {
    this.api = new Api()
    await this.checkUserToken()
    this.getGenres()
    await this.fetchRestaurants(0, this.filter)
  },
  methods: {
    fetchRestaurants : async function (currentPage, filter) {
      if (currentPage) {
        this.pagination.page = currentPage;
      }
      if (filter) {
        this.filter = filter;
      }

      const { data } = await RestaurantServices.findRestaurants(this.pagination, this.filter);
      this.similarRestaurants = data.items;
      this.pagination.total = data.total;

    },
    getGenres : function () {
      let param = [];
      let item;
      for (item in this.restaurant.genres) {
        param.push(this.restaurant.genres[item])
      }
      this.filter.genres = param.join(",")
    },

    async checkUserToken() {
      let token = this.loadToken()
      let userTokenInfo = await this.api.getToken(token);
      if (userTokenInfo === "") {
        this.logged = false;
      } else {
        this.logged = true;
      }
    },

    loadToken() {
      let token = this.$cookies.get('user_token');
      if (token !== null) {
        return token
      }
    },

  }
};
</script>

<style scoped>
.grid {
  display: grid;
  grid-template-columns: repeat(2, 50%);
  grid-gap: 15px;
}

@media screen and (max-width: 480px) {
  .grid {
    grid-template-columns: 100%;
  }
}
</style>
